import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { FaCheck } from 'react-icons/fa';

// item 482 — the iPhone-style sidebar nav badge: a red count pill when there's outstanding work,
// a green check when the area is all caught up. Compact in the collapsed rail (a corner dot), a
// fuller pill/check when expanded. Purely presentational — counts come from the wrapper.
interface Props {
  count: number;
  caughtUp?: boolean;
  collapsed?: boolean;
}

const NavBadge: React.FC<Props> = ({ count, caughtUp, collapsed }) => {
  if (caughtUp) {
    const d = collapsed ? '14px' : '18px';
    return (
      <Flex w={d} h={d} align="center" justify="center" borderRadius="full" bg="green.400" color="white" flexShrink={0} aria-label="All caught up">
        <Box as={FaCheck} fontSize={collapsed ? '8px' : '10px'} />
      </Flex>
    );
  }
  if (count > 0) {
    const label = count > 99 ? '99+' : String(count);
    return (
      <Flex
        minW={collapsed ? '16px' : '20px'}
        h={collapsed ? '16px' : '20px'}
        px={collapsed ? '3px' : '5px'}
        align="center"
        justify="center"
        borderRadius="full"
        bg="red.500"
        color="white"
        fontSize={collapsed ? '9px' : '11px'}
        fontWeight="bold"
        flexShrink={0}
        aria-label={`${count} outstanding`}
      >
        {label}
      </Flex>
    );
  }
  return null;
};

NavBadge.defaultProps = { caughtUp: false, collapsed: false };

export default NavBadge;
